import {RoadKillNormalBetPresentation} from "../RoadKillNormalBetPresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

export class RoadKillRespinBetPresentation extends RoadKillNormalBetPresentation {
    start(flowStateController: FlowStateController) {
        super.start(flowStateController);
    }
}